/* eslint-disable no-nested-ternary */
import React, { useState, useRef, useCallback } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { login } from "@/actions/auth";
import { Button, Form, Input, message } from "antd";

import logoImg from "@/assets/image/logo.png";
import styles from "./Login.module.scss";

type FieldType = {
  email?: string;
  password?: string;
};

const Login = (props) => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await props.login({ ...values });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.content}>
        <div className={styles.contentForm}>
          <div className={styles.title}>
            <img src={logoImg} alt="" />
            欢迎登录95AI
          </div>

          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            onFinish={onFinish}
            layout="vertical"
            autoComplete="off"
          >
            <Form.Item<FieldType>
              name="email"
              label="邮箱"
              rules={[{ required: true, message: "请填写您的邮箱" }]}
            >
              <Input
                className={styles.loginIuput}
                // prefix={<UserOutlined />}
                placeholder="请填写您的邮箱"
                autoComplete="off"
                readOnly={loading}
                allowClear
              />
            </Form.Item>

            <Form.Item<FieldType>
              name="password"
              label="密码"
              rules={[{ required: true, message: "请填写您的密码" }]}
            >
              <Input.Password
                className={styles.loginIuput}
                // prefix={<LockOutlined />}
                placeholder="请填写您的密码"
                autoComplete="off"
                readOnly={loading}
                allowClear
              />
            </Form.Item>

            <Button
              className={styles.loginButton}
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              登录
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default withRouter(connect(null, { login })(Login));
